<bmcore-producer-bg
  [producerCover]="beatmakerData?.backgroundImageUrl"
  [producerLogo]="beatmakerData?.backgroundLogoImageUrl"
>
</bmcore-producer-bg>
<!--<h4 style="position: absolute; color: white;text-align: center; top: 100px; background-color: rgba(0,0,0,0.2); width: 100%; padding: 10px 0">-->
<!--    Прежде чем деплоить приложение нужно заменить dev-mode на production-mode в-->
<!--    bmcore-tracks-page.component.html-->
<!--</h4>-->
<div class="common-section-wrapper common-section-wrapper--catalog theme-beats__bg">
  <div class="common-container" [ngClass]="{ 'common-container--color-settings': colorSettingsMode }">
    <h2 class="common-section-title theme-beats__title">{{ lg.tracksBlock.heading }}</h2>
    <bmcore-tracks-block
      [appType]="'PROD-PAGE'"
      [isTracksPage]="false"
      [isShowTracksAllBeatmakers]="false"
      [pageSize]="10"
      [producerId]="beatmakerData?.beatmakerId"
      [pagesWithFilter]="'no-filter'"
      [currentSortById]="beatmakerData?.defaultBeatsSorting"
    >
    </bmcore-tracks-block>
  </div>
</div>

<!-- License block -->
<div class="common-section-wrapper common-section-wrapper--licenses theme-licenses__bg">
  <div class="common-container" [ngClass]="{ 'common-container--color-settings': colorSettingsMode }">
    <ng-container>
      <h2 class="common-section-title theme-licenses__title">{{ lg.licenseBlock.heading }}</h2>
      <bmcore-license-slider
        [licenses]="licenses"
        [licenseBulkDiscounts]="licenseBulkDiscounts"
        [btnInLicenseName]="'to beat list'"
        [toBeatListBtnRoute]="'catalog'"
      >
      </bmcore-license-slider>
    </ng-container>
  </div>
</div>

<!-- Contacts block -->
<div class="common-section-wrapper common-section-wrapper--contacts theme-contacts__bg">
  <div class="common-container" [ngClass]="{ 'common-container--color-settings': colorSettingsMode }">
    <bmcore-contacts-block
      [socialContacts]="beatmakerData.contacts"
      [emailSecret]="beatmakerData.emailSecret"
      [beatmakerId]="beatmakerData.beatmakerId"
      [beatmakerName]="beatmakerData.beatmakerName"
      [sourceType]="sourceType"
      [appType]="'PROD-PAGE'"
    >
    </bmcore-contacts-block>
  </div>
</div>

<div class="common-section-wrapper common-section-wrapper--newsletter theme-newsletter">
  <div class="common-container" [ngClass]="{ 'common-container--color-settings': colorSettingsMode }">
    <bmcore-newsletter-block></bmcore-newsletter-block>
  </div>
</div>
